import { render, staticRenderFns } from "./EventModalCatalogPreviewDocuments.vue?vue&type=template&id=9ad5e0f8&scoped=true"
import script from "./EventModalCatalogPreviewDocuments.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogPreviewDocuments.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogPreviewDocuments.vue?vue&type=style&index=0&id=9ad5e0f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad5e0f8",
  null
  
)

export default component.exports